__turbopack_context__.v({
  "className": "poppins_2f8a1a4c-module__FYXtHa__className",
});
